import {Attrs, EventListeners, MinzeElement, Reactive} from "minze";
import {Locale} from "../../modules/locale";
import {MODALS} from "../../constants";
import { SquidexTextLabels } from "../../modules/squidex/labels";

export interface TjTrainingPopupForm {
  query: string,
  submitted: boolean
}

Locale.getInstance().registerKeySet("fr", "trainingPopupForm", {
  "title": "Éducation à la sexualité des ados",
  "subtitle": "Compléter ce formulaire et nous vous contacterons dans les plus brefs délais afin de confirmer notre passage dans votre école.",
  "successMessage": `Demande envoyée!\n
  Nous communiquerons avec vous sous peu.`,
  "closeButton": "Fermer",
  "openButton": "Inscrire un groupe"
});

Locale.getInstance().registerKeySet("en", "trainingPopupForm", {
  "title": "Sex Education for Teenagers",
  "subtitle": "Complete this form and we will be in contact shortly to confirm our visit at your school.",
  "successMessage": `Request sent!\n
  We will contact you shortly.`,
  "closeButton": "Close",
  "openButton": "Register a group"
});

export class TjTrainingPopupForm extends MinzeElement {
  attrs: Attrs = [
    ["data-button-size", "large"],
    ["data-button-text", `${SquidexTextLabels.getKey("trainingPopupForm.openButton")}`]
  ]
  reactive: Reactive = [
    ["submitted", false]
  ];

  openModal() {
    const mainModule = window.TJ_MAIN_MODULE;
    mainModule.showModal(MODALS.CONTACT_POPUP);
  }

  closeModal() {
    const mainModule = window.TJ_MAIN_MODULE;
    mainModule.hideModal(MODALS.CONTACT_POPUP);
  }

  onSubmitted() {
    this.submitted = true;
    this.rerender();
  }

  html = () => /* html */ `
    <tj-popup-form
      data-modal-id="${MODALS.CONTACT_POPUP}"
      data-button-label="${this.dataButtonText}"
      data-button-size="${this.dataButtonSize}"
    >
      <div slot="tj-content">
        ${this.submitted ? `
          <tj-box display="flex" flexDirection="column" justifyContent="center" alignItems="center" padding="30px 0">
           <tj-text text-align="center" font-size="20px">
             ${SquidexTextLabels.getKey("trainingPopupForm.successMessage")}
           </tj-text>
           <tj-box mt="32px" width="fit-content">
             <tj-button id="close-button" width="fit-content" data-button-size="small">
              ${SquidexTextLabels.getKey("trainingPopupForm.closeButton")}
             </tj-button>
           </tj-box>
          </tj-box>
        ` : `
          <tj-background-arrow-icon></tj-background-arrow-icon>
          <tj-box mb="32px">
            <tj-text color="#133762" font-size="34px" font-weight="500">
              ${SquidexTextLabels.getKey("trainingPopupForm.title")}
            </tj-text>
          </tj-box>
          <tj-training-form></tj-training-form>
        `}
      </div>
    </tj-popup-form>
  `;

  css = () => `
    tj-background-arrow-icon {
      position: absolute;
      top: 0;
      left: 0;
    }
  `;

  eventListeners: EventListeners = [
    ["#open-modal", "click", this.openModal],
    ["#close-button", "click", this.closeModal],
    [window, "tj:training-form-submitted", this.onSubmitted.bind(this)]
  ];
}
